import { Button } from '@dehaat/dds';
import useTranslation from 'next-translate/useTranslation';
import { useCallback, useEffect, useState } from 'react';
import { getCurrentLocationValues, LocationType } from '@/utils/google';
import Paragraph, { VARIANT } from '../Paragraph';
import Spinner from '../Spinner';
interface Props {
  getCurrentLatLong: ({
    latitude,
    longitude
  }: LocationType) => void;
}
const TakeCurrentLocation = ({
  getCurrentLatLong
}: Props) => {
  const {
    t
  } = useTranslation('location');
  const [locationPermissionLoading, setLocationPermissionLoading] = useState(false);
  const [locationPermissionGranted, setLocationPermissionGranted] = useState(false);
  const [showEnablePermission, setShowEnablePermission] = useState(false);
  const getLatLong = useCallback(async () => {
    setLocationPermissionLoading(true);
    const location = await getCurrentLocationValues();
    if (location) {
      getCurrentLatLong(location);
      setLocationPermissionGranted(true);
    } else {
      setLocationPermissionGranted(false);
    }
    setLocationPermissionLoading(false);
  }, [getCurrentLatLong]);
  useEffect(() => {
    getLatLong();
  }, [getLatLong]);
  if (locationPermissionLoading) {
    return <Spinner />;
  }
  if (!locationPermissionLoading && !locationPermissionGranted) {
    return <section className="p-4 bg-white">
        <div className="p-2 font-medium mb-2 text-center">
          <Paragraph variant={VARIANT.BIG} className="text-error-90">
            {t('access_denied')}
          </Paragraph>
          <Paragraph variant={VARIANT.MEDIUM} className="text-neutral-80 font-semibold">
            {t('access_denied_subtext')}
          </Paragraph>
          {!locationPermissionLoading && !locationPermissionGranted && showEnablePermission && <div className="mt-2 px-4 w-full">
                <Paragraph className="border border-error-90 bg-error-10 mx-auto px-4 py-2 rounded-xl text-center text-error-90 w-fit" variant={VARIANT.MEDIUM}>
                  {t('enable_location_permission')}
                </Paragraph>
              </div>}
        </div>

        <Button text={t('try_again')} onClick={() => {
        getLatLong();
        setShowEnablePermission(true);
      }} />
      </section>;
  } else {
    return <></>;
  }
};
export default TakeCurrentLocation;